import { render } from "./ContainerNoList.vue?vue&type=template&id=a7ca8fa6"
import script from "./ContainerNoList.vue?vue&type=script&lang=js"
export * from "./ContainerNoList.vue?vue&type=script&lang=js"
script.render = render

export default script